<div class="page-header">
  <h2>{{ pageTitle }}</h2>
  <button mat-stroked-button type="button" routerLink="/org/list">
    <mat-icon>arrow_back</mat-icon>
    К списку
  </button>
</div>

<form class="form-container" [formGroup]="createForm" (ngSubmit)="submit()">
  <mat-progress-bar *ngIf="loading || saving || accountsLoading" mode="indeterminate"></mat-progress-bar>

  <mat-tab-group animationDuration="200ms">
    <mat-tab label="Основное">
      <div class="tab-content">
        <div class="grid two-columns">
          <mat-form-field appearance="outline">
            <mat-label>Название</mat-label>
            <input matInput formControlName="name" placeholder="Название организации" />
            <mat-error *ngIf="createForm.get('name')?.hasError('required')">Обязательное поле</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Полное название</mat-label>
            <input matInput formControlName="fullName" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>ЕДРПОУ</mat-label>
            <input matInput formControlName="edrpou" maxlength="10" />
            <mat-error *ngIf="createForm.get('edrpou')?.hasError('minlength') || createForm.get('edrpou')?.hasError('maxlength')">
              Длина ЕДРПОУ: 8-10 символов
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>ИНН</mat-label>
            <input matInput formControlName="ipn" maxlength="12" />
            <mat-error *ngIf="createForm.get('ipn')?.hasError('minlength') || createForm.get('ipn')?.hasError('maxlength')">
              Длина ИНН: 10-12 символов
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Система налогообложения</mat-label>
            <mat-select formControlName="taxationType">
              <mat-option *ngFor="let type of taxationTypes" [value]="type">{{ type }}</mat-option>
            </mat-select>
          </mat-form-field>

          <div class="status-field">
            <mat-checkbox formControlName="isActive">Организация активна</mat-checkbox>
          </div>
        </div>

        <h3>Печать видатковой накладной</h3>
        <p id="shipment-signatory-hint">
          ФИО и должность отпустившего товар — необязательные поля для печати.
          Если оставить их пустыми, для ФОП подставятся данные предпринимателя,
          а для остальных организаций останутся строки для заполнения вручную.
        </p>
        <div class="grid two-columns">
          <mat-form-field appearance="outline">
            <mat-label>Отпустил товар — ФИО</mat-label>
            <input matInput formControlName="shipmentSignatoryName" maxlength="200" aria-describedby="shipment-signatory-hint" />
            <mat-error *ngIf="createForm.get('shipmentSignatoryName')?.hasError('maxlength')">Не более 200 символов</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Отпустил товар — должность</mat-label>
            <input matInput formControlName="shipmentSignatoryPosition" maxlength="120" aria-describedby="shipment-signatory-hint" />
            <mat-error *ngIf="createForm.get('shipmentSignatoryPosition')?.hasError('maxlength')">Не более 120 символов</mat-error>
          </mat-form-field>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Адреса и контакты">
      <div class="tab-content">
        <div class="grid two-columns">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Юридический адрес</mat-label>
            <input matInput formControlName="legalAddress" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Фактический адрес</mat-label>
            <input matInput formControlName="actualAddress" />
          </mat-form-field>

          <div class="copy-address">
            <button mat-stroked-button type="button" (click)="copyLegalAddressToActual()">
              Копировать юридический адрес в фактический
            </button>
          </div>

          <div></div>

          <mat-form-field appearance="outline">
            <mat-label>Телефон</mat-label>
            <input matInput formControlName="phone" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" />
            <mat-error *ngIf="createForm.get('email')?.hasError('email')">Некорректный email</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>ID директора</mat-label>
            <input matInput type="number" formControlName="director_id" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>ID бухгалтера</mat-label>
            <input matInput type="number" formControlName="accountant_id" />
          </mat-form-field>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Банковские счета">
      <div class="tab-content">
        <div class="accounts-header">
          <h3>Счета организации</h3>
          <button type="button" mat-stroked-button color="primary" (click)="addBankAccountRow()">
            <mat-icon>add</mat-icon>
            Добавить счет
          </button>
        </div>

        <div class="accounts-empty" *ngIf="!bankAccountForms.length">
          <p>Счета не добавлены</p>
        </div>

        <div class="accounts-list">
          <div class="account-card" *ngFor="let ctrl of bankAccountForms; let i = index" [formGroup]="ctrl">
            <div class="account-card-header">
              <h4>Счет #{{ i + 1 }}</h4>
              <button type="button" mat-icon-button color="warn" (click)="removeBankAccountRow(i)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>

            <div class="grid two-columns">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>IBAN</mat-label>
                <input matInput formControlName="iban" placeholder="UA123..." />
                <mat-error *ngIf="ctrl.get('iban')?.hasError('required')">Обязательное поле</mat-error>
                <mat-error *ngIf="ctrl.get('iban')?.hasError('pattern')">Формат: UA + 27 цифр</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Банк</mat-label>
                <input matInput formControlName="bankName" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Название счета</mat-label>
                <input matInput formControlName="accountName" />
              </mat-form-field>

              <div class="account-flags">
                <mat-checkbox
                  [checked]="ctrl.get('isPrimary')?.value"
                  (change)="setPrimary(i, $event.checked)"
                >
                  Основной
                </mat-checkbox>
                <mat-checkbox formControlName="isActive">Активный</mat-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>

  <div class="actions">
    <button mat-flat-button color="primary" type="submit" [disabled]="saving || loading || accountsLoading">
      <mat-icon>save</mat-icon>
      {{ isEditMode ? 'Сохранить изменения' : 'Создать организацию' }}
    </button>
    <button mat-stroked-button type="button" routerLink="/org/list" [disabled]="saving">
      Отмена
    </button>
  </div>
</form>
